module.exports = __webpack_public_path__ + "static/media/bubble-pop.08d77917.webm";